import { resolveTheme } from '../themes';
import { KHLogo, KCLogo, KHLogoWhite, KCLogoWhite } from '../assets/images/svgs';
import { THEME_ID } from '../themes/types';

const theme = resolveTheme();
const isKC = theme.id === THEME_ID.KINDLY_CHRISTIAN;

/**
 * Default logo for the current domain/theme (Kindly Human or Kindly Christian).
 * Use wherever KHLogo was used for theme-aware logo display.
 */
export const domainLogo = isKC ? KCLogo : KHLogo;

/**
 * Alt text for the domain logo.
 */
export const domainLogoAlt = isKC ? 'Kindly Christian' : 'Kindly Human';

/**
 * White/light logo for dark backgrounds (e.g. footer).
 * Use wherever KHLogoWhite was used.
 */
export const domainLogoWhite = isKC ? KCLogoWhite : KHLogoWhite;
